import { Outlet } from "react-router-dom";
import { Analytics } from "@vercel/analytics/react";
import { Header, Footer } from "./components/compIndex";

function App() {
  return (
    <div className="relative flex min-h-screen flex-col">
      <div className="flex-1">
        <Outlet />
      </div>
      <Footer />
      <Header />
      <Analytics />
    </div>
  );
}

export default App;
